import { i18n } from '../i18n';

export const containerStatusLabel: any = {
  GATED_IN: i18n.t('common.gatedIn'),
  GATED_OUT: i18n.t('common.gatedOut'),
  GATE_OUT_REQUESTED: i18n.t('common.gateOutRequested'),
};

export const containerConditionsLabel = {
  NEW: i18n.t('dropdown.NEW'),
  CW: i18n.t('dropdown.CW'),
  IICL: i18n.t('dropdown.IICL'),
  WWT: i18n.t('dropdown.WWT'),
  AS_IS: i18n.t('dropdown.AS_IS'),
};

export const rolesLabel: any = {
  SUPER_ADMIN: i18n.t('common.superAdmin'),
  YARD_COMPANY_ADMIN: i18n.t('common.yardCompanyAdmin'),
  YARD_COMPANY_EMPLOYEE: i18n.t('common.yardCompanyEmployee'),
  YARD_COMPANY_VIEWER: i18n.t('common.yardCompanyViewer'),
  YARD_MANAGER: i18n.t('common.yardManager'),
  YARD_DISPATCHER: i18n.t('common.yardDispatcher'),
  YARD_CRANE_OPERATOR: i18n.t('common.yardCraneOperator'),
  CLIENT_MANAGER: i18n.t('common.clientManager'),
  CLIENT_DISPATCHER: i18n.t('common.clientDispatcher'),
};

export const signinRolesValue: any = {
  YardCompanyAdmin: 'YARD_COMPANY_ADMIN',
  YardCompanyEmployee: 'YARD_COMPANY_EMPLOYEE',
  YardCompanyViewer: 'YARD_COMPANY_VIEWER',
  YardManager: 'YARD_MANAGER',
  YardDispatcher: 'YARD_DISPATCHER',
  YardCraneOperator: 'YARD_CRANE_OPERATOR',
  ClientManager: 'CLIENT_MANAGER',
  ClientDispatcher: 'CLIENT_DISPATCHER',
};

export const viewCompanyLabel: any = {
  yardcompanies: i18n.t('common.yardCompany'),
  yards: i18n.t('label.yardName'),
  clients: i18n.t('label.clientName'),
};

export const viewCompanyTitle: any = {
  yardcompanies: i18n.t('common.yardCompany'),
  yards: i18n.t('common.yard'),
  clients: i18n.t('common.clientCompany'),
};

export const employeesTableCompanyTitle: any = {
  YardCompany: i18n.t('common.yardCompany'),
  Yard: i18n.t('label.yardName'),
  Client: i18n.t('common.clientCompany'),
};

export const employeesViewLabel: any = {
  YardCompany: i18n.t('common.yardCompany'),
  Yard: i18n.t('common.yard'),
  Client: i18n.t('common.client'),
};

export const employeesRolesLabel: any = {
  SuperAdmin: i18n.t('common.superAdmin'),
  YardCompanyAdmin: i18n.t('common.yardCompanyAdmin'),
  YardCompanyEmployee: i18n.t('common.yardCompanyEmployee'),
  YardCompanyViewer: i18n.t('common.yardCompanyViewer'),
  YardManager: i18n.t('common.yardManager'),
  YardDispatcher: i18n.t('common.yardDispatcher'),
  YardCraneOperator: i18n.t('common.yardCraneOperator'),
  ClientManager: i18n.t('common.clientManager'),
  ClientDispatcher: i18n.t('common.clientDispatcher'),
};

export const clientYardModalLabel: any = {
  'add-clients': i18n.t('label.addClients'),
  'reactivate-clients': i18n.t('label.reactivateClients'),
  'deactivate-clients': i18n.t('label.deactivateClients'),
  'add-yards': i18n.t('label.addYards'),
  'reactivate-yards': i18n.t('label.reactivateYards'),
  'deactivate-yards': i18n.t('label.deactivateYards'),
};

export const clientYardModalPlaceholder: any = {
  'add-clients': i18n.t('label.selectClients'),
  'reactivate-clients': i18n.t('label.selectClients'),
  'deactivate-clients': i18n.t('label.selectClients'),
  'add-yards': i18n.t('label.selectYards'),
  'reactivate-yards': i18n.t('label.selectYards'),
  'deactivate-yards': i18n.t('label.selectYards'),
};

export const pricingFormLabels = {
  loaded: (containerType: string) => i18n.t('label.pricing.loadedFc', { containerType }),
  empty: (containerType: string) => i18n.t('label.pricing.emptyFc', { containerType }),
  loadedCraneIn: (containerType: string) =>
    i18n.t('label.pricing.loadedCraneInFc', { containerType }),
  loadedCraneOut: (containerType: string) =>
    i18n.t('label.pricing.loadedCraneOutFc', { containerType }),
  emptyCraneIn: (containerType: string) =>
    i18n.t('label.pricing.emptyCraneInFc', { containerType }),
  emptyCraneOut: (containerType: string) =>
    i18n.t('label.pricing.emptyCraneOutFc', { containerType }),
};

export const QueueStatusToChipLabels = {
  WAITING: i18n.t('label.chip.waiting'),
  LOADING: i18n.t('label.chip.loading'),
  DONE: i18n.t('label.chip.done'),
};

export const ContainerStatusToChipLabels = {
  IN_TRANSIT: i18n.t('label.chip.inTransit'),
  GATED_IN: i18n.t('label.chip.gatedIn'),
  FOR_SALE: i18n.t('label.chip.forSale'),
  AWAITING_PAYMENT: i18n.t('label.chip.awaitingPayment'),
  SOLD_INST: i18n.t('label.chip.soldInstallment'),
  SOLD: i18n.t('label.chip.sold'),
  GATED_OUT: i18n.t('label.chip.gatedOut'),
  GATE_OUT_REQUESTED: i18n.t('label.chip.gateOutRequested'),
  GATE_OUT_EXPIRED: i18n.t('label.chip.gateOutExpired'),
  NOT_FOUND: i18n.t('label.chip.notFound'),
  HOLD: i18n.t('label.chip.hold'),
};

export const ContainerConditionToChipLabels = {
  NEW: i18n.t('label.chip.new'),
  CW: i18n.t('label.chip.cw'),
  IICL: i18n.t('label.chip.iicl'),
  WWT: i18n.t('label.chip.wwt'),
  AS_IS: i18n.t('label.chip.asIs'),
};

export const GateStatusToChipLabels = {
  ACTIVE: i18n.t('label.chip.active'),
  LOADING_ALLOWED: i18n.t('label.chip.loadingAllowed'),
  EXPIRED: i18n.t('label.chip.expired'),
  LOADED: i18n.t('label.chip.loaded'),
  COMPLETED: i18n.t('label.chip.completed'),
  DELETED: i18n.t('label.chip.deleted'),
};

export const StoragePricingStatusToLabels = {
  ACTIVE: i18n.t('label.chip.active'),
  MISSING: i18n.t('label.chip.missing'),
};

export const ContainerIsLoadedToChipLabels = {
  LOADED: i18n.t('label.chip.loaded'),
  EMPTY: i18n.t('label.chip.empty'),
};

export const RepairStatusToChipLabels = {
  DRAFT: i18n.t('label.chip.draft'),
  PENDING: i18n.t('label.chip.pending'),
  ACTIVE: i18n.t('label.chip.active'),
  REJECTED: i18n.t('label.chip.rejected'),
  COMPLETED: i18n.t('label.chip.completed'),
};

export const RepairInvoiceStatusToChipLabels = {
  UNCREATED: i18n.t('label.chip.uncreated'),
  CREATED: i18n.t('label.chip.created'),
};

export const InventoryStatusToChipLabels = {
  IN_PROGRESS: i18n.t('label.chip.inProgress'),
  COMPLETED: i18n.t('label.chip.finished'),
};

export const InventoryItemStatusToChipLabels = {
  NOT_FOUND: i18n.t('label.chip.notFound'),
  EXTRA_FOUND: i18n.t('label.chip.extraFound'),
  FOUND: i18n.t('label.chip.found'),
};

export const InvoiceModeToChipLabels = {
  AUTO: i18n.t('label.chip.auto'),
  MANUAL: i18n.t('label.chip.manual'),
};

export const InvoiceTypeToChipLabels = {
  ALL: i18n.t('label.chip.all'),
  STORAGE: i18n.t('label.chip.storage'),
  CRANE: i18n.t('label.chip.crane'),
  OTHER: i18n.t('label.chip.other'),
};

export const InvoiceStatusToChipLabels = {
  DRAFT: i18n.t('label.chip.draft'),
  PENDING: i18n.t('label.chip.pending'),
  PAID: i18n.t('label.chip.paid'),
};

export const SaleStatusToChipLabels = {
  FOR_SALE: i18n.t('label.chip.forSale'),
  AWAITING_PAYMENT: i18n.t('label.chip.awaitingPayment'),
  SOLD_INST: i18n.t('label.chip.soldInstallment'),
  SOLD: i18n.t('label.chip.sold'),
  NOT_FOUND: i18n.t('label.chip.notFound'),
};

export const OfferStatusAdminToChipLabels = {
  NOT_SELECTED: i18n.t('label.chip.notSelected'),
  CANCELLED_BY_SELLER: i18n.t('label.chip.cancelledBySeller'),
  CANCELLED_BY_BUYER: i18n.t('label.chip.cancelledByBuyer'),
  CANCELLED_BY_ADMIN: i18n.t('label.chip.cancelledByAdmin'),
  CANCELLED_BY_SYSTEM: i18n.t('label.chip.cancelledBySystem'),
  RECEIVED: i18n.t('label.chip.received'),
  REJECTED: i18n.t('label.chip.rejected'),
  ACCEPTED: i18n.t('label.chip.awaitingPayment'),
  SOLD_INST: i18n.t('label.chip.soldInstallment'),
  CLOSED: i18n.t('label.chip.paid'),
  NOT_FOUND: i18n.t('label.chip.notFound'),
};

export const OfferStatusSentToChipLabels = {
  NOT_SELECTED: i18n.t('label.chip.notSelected'),
  CANCELLED_BY_SELLER: i18n.t('label.chip.cancelledBySeller'),
  CANCELLED_BY_BUYER: i18n.t('label.chip.cancelled'),
  CANCELLED_BY_ADMIN: i18n.t('label.chip.cancelledByAdmin'),
  CANCELLED_BY_SYSTEM: i18n.t('label.chip.cancelledBySystem'),
  RECEIVED: i18n.t('label.chip.sent'),
  REJECTED: i18n.t('label.chip.rejected'),
  ACCEPTED: i18n.t('label.chip.paymentRequierd'),
  SOLD_INST: i18n.t('label.chip.installmentRequierd'),
  CLOSED: i18n.t('label.chip.paid'),
  NOT_FOUND: i18n.t('label.chip.notFound'),
};

export const OfferStatusReceivedToChipLabels = {
  NOT_SELECTED: i18n.t('label.chip.notSelected'),
  CANCELLED_BY_SELLER: i18n.t('label.chip.cancelled'),
  CANCELLED_BY_BUYER: i18n.t('label.chip.cancelledByBuyer'),
  CANCELLED_BY_ADMIN: i18n.t('label.chip.cancelledByAdmin'),
  CANCELLED_BY_SYSTEM: i18n.t('label.chip.cancelledBySystem'),
  RECEIVED: i18n.t('label.chip.received'),
  REJECTED: i18n.t('label.chip.rejected'),
  ACCEPTED: i18n.t('label.chip.awaitingPayment'),
  SOLD_INST: i18n.t('label.chip.soldInstallment'),
  CLOSED: i18n.t('label.chip.paid'),
  NOT_FOUND: i18n.t('label.chip.notFound'),
};

export const SalesFeeStatusToLabels = {
  ACTIVE: i18n.t('label.chip.active'),
  MISSING: i18n.t('label.chip.missing'),
};

export const EmployeeAccountStatusToChipLabels = {
  ACTIVE: i18n.t('label.chip.active'),
  DEACTIVATED: i18n.t('label.chip.deactivated'),
};
